export const tableColumns = [
    { name: 'Name', value: 'name', fieldValue: 'name', isSortable: true, langKey: "name" },
    { name: 'Date Added', value: 'dateAdded', fieldValue: 'dateAdded', isSortable: true, langKey: "date-added" },
];
export const defaultTableColumns = ['name', 'dateAdded'];
export const SORT_QUERY_SELECTOR = 'documentsSort';
